module.exports = __webpack_public_path__ + "img/btnCard-7-m.67fc964a.jpg";